import '../vendor';

import '../general/ofi';
import '../general/anchor';
import '../general/menu.js';
import '../general/find';
import '../general/search-clear';
import '../general/aside-filter';
import '../general/filters';
import '../general/aside-inputs';

import './materials/aside-accordion';
import './materials/aside-key-words';
import './materials/aside-periods';
import './materials/aside-select';
import './materials/periods';
import './materials/search-autocomplete';
import './materials/input-work';


// WEBPACK FOOTER //
// ./src/js/pages/materials.js